import { render, staticRenderFns } from "./NetgsmChannels.vue?vue&type=template&id=7b6abb72&scoped=true"
import script from "./NetgsmChannels.vue?vue&type=script&lang=js"
export * from "./NetgsmChannels.vue?vue&type=script&lang=js"
import style0 from "./NetgsmChannels.vue?vue&type=style&index=0&id=7b6abb72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6abb72",
  null
  
)

export default component.exports